import React from "react";
import { DPTabs } from "Components/DP";
import { Route, Switch } from "react-router";
import { DDUConsentReport } from "../DDUConsentReport/DDUConsentReport";
import { PaystubReport } from "../PaystubReport/PaystubReport";
import { CashBalanceReport } from "../CashBalanceReport/CashBalanceReport";
import InternalRoutes from "Shared/Constants/InternalRoutes";

export interface ComplianceReportingsTabsProps {
  tabIndex: number;
  tabLabels: string[];
  handleTabChange: (newTabIndex: number) => void;
}

export const ComplianceReportsTabs = ({
  tabIndex,
  tabLabels,
  handleTabChange,
}: ComplianceReportingsTabsProps) => {
  return (
    <DPTabs
      labels={tabLabels}
      tabIndex={tabIndex}
      onChange={(_: React.ChangeEvent<unknown>, value: number) => {
        handleTabChange(value);
      }}
    >
      {/* TODO: Uncomment report routes once API Calls are available for those reports */}
      <Switch>
        <Route
          path={InternalRoutes.paystubReport}
          render={() => <PaystubReport />}
        />
        <Route
          path={InternalRoutes.cashBalanceReport}
          render={() => <CashBalanceReport />}
        />
        <Route
          path={InternalRoutes.dduConsentReport}
          render={() => <DDUConsentReport />}
        />
        {/* <Route
          path="/compliance-reports/canceled-users"
          render={() => <CanceledUsersReport />}
        /> */}
      </Switch>
    </DPTabs>
  );
};
